import {Console} from 'console'
import {
  Document,
  AlignmentType,
  BorderStyle,
  convertInchesToTwip,
  Footer,
  Header,
  ImageRun,
  Packer,
  PageNumber,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  WidthType,
  TableWidthElement,
  Alignment,
} from 'docx'
import {saveAs} from 'file-saver'
import {Children} from 'react'
import {SearchBankAccount} from './AccountSearch'
import {memorandum} from '../../../_metronic/assets/ts'

export default function exportEmptyBbaDocx(
  accounts: SearchBankAccount[],
  iba: boolean,
  bba: boolean,
  issuerDocumentId: string,
  requesteeDocumentId: string,
  requesteeFullName: string,
  legalBasisNote: string,
  documentPurposeNote: string,
  selectedItem: any,
  RequesteeAddress: string,
  content: string,
  footerArticle: any,
  uploadchecker: any,
  FullName: string,
  uniqueNationalIdValue: string,
  businessEntityIdValue: string,
  glavni: boolean,
  uniqueEntityIdG: string,
  entityNameG: string
) {
  const today = new Date().toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })

  const x = iba
    ? uniqueNationalIdValue
    : businessEntityIdValue && bba && businessEntityIdValue
    ? businessEntityIdValue
    : uniqueEntityIdG
  const EntityNameW = entityNameG
  const array = [{EntityNameW, x}]

  const items = array.map((item: any, index: any) => {
    return new TableRow({
      children: [
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.69),
          //   right: convertInchesToTwip(0.69),
          // },
          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text: EntityNameW ?? '',
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.19),
          //   right: convertInchesToTwip(0.19),
          // },

          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text: iba
                ? uniqueNationalIdValue
                : bba && businessEntityIdValue !== ''
                ? businessEntityIdValue
                : bba && businessEntityIdValue === ''
                ? uniqueEntityIdG
                : '',
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
      ],
    })
  })

  const table = new Table({
    alignment: AlignmentType.CENTER,
    indent: {
      size: 1666,
      type: WidthType.PERCENTAGE,
    },
    rows: [
      new TableRow({
        tableHeader: true,
        children: [
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.61),
              right: convertInchesToTwip(0.61),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: iba ? 'Ime i prezime' : bba ? 'Naziv poslovnog subjekta' : '',
                alignment: AlignmentType.CENTER,
                style: 'table-header',
              }),
            ],
          }),
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.19),
              right: convertInchesToTwip(0.19),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: iba ? 'JMB' : bba ? 'JIB' : '',
                alignment: AlignmentType.CENTER,
                style: 'table-header',
              }),
            ],
          }),
        ],
      }),

      ...items,

      new TableRow({
        children: [
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.51),
              right: convertInchesToTwip(0.51),
            },
            verticalAlign: VerticalAlign.CENTER,
            //  shading: { fill: '336799' },
            columnSpan: 2,
            children: [
              new Paragraph({
                //text:`${content}`,
                text: iba
                  ? 'NEMA EVIDENTIRANIH RAČUNA U REGISTRU RAČUNA FIZIČKIH LICA'
                  : !glavni && bba
                  ? 'NEMA EVIDENTIRANIH RAČUNA U REGISTRU RAČUNA POSLOVNIH SUBJEKATA U FBIH'
                  : 'NEMA EVIDENTIRAN GLAVNI RAČUN U REGISTRU RAČUNA POSLOVNIH SUBJEKATA U FBIH',
                alignment: AlignmentType.CENTER,
              }),
            ],
          }),
        ],
      }),
    ],
  })

  const mainContent = table

  const text = iba

  const doc = new Document({
    styles: {
      default: {},
      paragraphStyles: [
        {
          id: 'table-header',
          basedOn: 'Normal',
          quickFormat: true,
          run: {
            size: 18,
            font: 'Cambria',
            color: 'ffffff',
          },
        },
        {
          id: 'table-cell',
          basedOn: 'Normal',
          quickFormat: true,
          run: {
            size: 18,
            font: 'Cambria',
          },
        },
        {
          id: 'signature',
          basedOn: 'table-cell',
          quickFormat: true,
          run: {
            size: 22,
            font: 'Cambria',
          },
        },
        {
          id: 'footer',
          basedOn: 'Normal',
          quickFormat: true,
          run: {
            size: 16,
            font: 'Cambria',
            // bold: true
          },
        },
        {
          id: 'normal',
          name: 'Normal1',
          basedOn: 'Normal',
          next: 'Normal',
          quickFormat: true,
          run: {
            size: 22,
            font: 'Cambria',
          },
          paragraph: {
            spacing: {
              after: 120,
            },
          },
        },
        {
          id: 'bold',
          name: 'Bold 2',
          basedOn: 'Normal',
          next: 'Normal',
          quickFormat: true,
          run: {
            size: 22,
            bold: true,
            font: 'Cambria',
          },
          paragraph: {
            spacing: {
              before: 340,
              after: 0,
            },
          },
        },
        {
          id: 'bold-normal',
          name: 'Bold 2',
          basedOn: 'Normal',
          next: 'Normal',
          quickFormat: true,
          run: {
            size: 22,
            bold: true,
            font: 'Cambria',
          },
          paragraph: {
            spacing: {
              after: 0,
            },
          },
        },
        {
          id: 'aside',
          name: 'Aside',
          basedOn: 'Normal',
          next: 'Normal',
          run: {
            color: '999999',
            italics: true,
          },
          paragraph: {
            indent: {
              left: 720,
            },
            spacing: {
              line: 276,
            },
          },
        },
        {
          id: 'wellSpaced',
          name: 'Well Spaced',
          basedOn: 'Normal',
          quickFormat: true,
          paragraph: {
            spacing: {line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05},
          },
        },
        {
          id: 'ListParagraph',
          name: 'List Paragraph',
          basedOn: 'Normal',
          quickFormat: true,
        },
      ],
    },
    sections: [
      {
        properties: {
          page: {
            margin: {
              top: 800,
              right: 1000,
              // bottom: 0,
              left: 1000,
            },
          },
        },
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                spacing: {
                  after: 200,
                },
                children: [
                  new ImageRun({
                    data: Uint8Array.from(atob(memorandum), (c) => c.charCodeAt(0)),
                    transformation: {
                      width: 259.16,
                      height: 62.32,
                    },
                  }),
                ],
              }),
            ],
          }),
        },

        children: [
          new Paragraph(''),
          new Paragraph({
            text: `Broj: ${issuerDocumentId}`,
            style: 'normal',
          }),
          new Paragraph({
            text: `Sarajevo, ${today} godine`,
            style: 'normal',
          }),
          new Paragraph({
            text: `Podnosilac zahtjeva:`,
            style: 'bold',
          }),
          new Paragraph({
            text: `${requesteeFullName}`,
            style: 'bold-normal',
          }),
          new Paragraph({
            text: `${RequesteeAddress}`,
            style: 'bold-normal',
          }),

          new Paragraph({
            text: `Poziv na broj: ${requesteeDocumentId}`,
            style: 'bold-normal',
            spacing: {before: 200, after: 100},
          }),
          new Paragraph({
            text:
              bba && glavni
                ? 'POTVRDA/IZVOD O GLAVNOM RAČUNU IZ JEDINSTVENOG REGISTRA RAČUNA POSLOVNIH SUBJEKATA FEDERACIJE BIH'
                : bba
                ? 'POTVRDA/IZVOD O OTVORENIM RAČUNIMA IZ JEDINSTVENOG REGISTRA RAČUNA POSLOVNIH SUBJEKATA FEDERACIJE BIH'
                : '',
            style: 'bold',
            alignment: AlignmentType.CENTER,
            spacing: {before: 600, after: 400},
            keepLines: true,
            keepNext: true,
          }),
          mainContent,
          new Paragraph({
            children: [new TextRun({text: `${selectedItem.label1}`, bold: true})],
            style: 'signature',
            alignment: AlignmentType.END,
            spacing: {before: selectedItem.verticalSpacing1},
            indent: {right: selectedItem.rightIndentLine1},
            keepLines: true,
            keepNext: true,
            widowControl: true,
          }),
          new Paragraph({
            children: [new TextRun({text: `${selectedItem.label2}`, bold: false})],
            style: 'signature',
            alignment: AlignmentType.END,
            spacing: {before: selectedItem.verticalSpacing2},
            indent: {right: selectedItem.rightIndentLine2},
            keepLines: true,
            keepNext: true,
            widowControl: true,
          }),
          new Paragraph({
            children: [new TextRun({text: `${selectedItem.label3}`, bold: false})],
            style: 'signature',
            spacing: {before: selectedItem.verticalSpacing3},
            indent: {right: selectedItem.rightIndentLine3},
            alignment: AlignmentType.END,
            keepLines: true,
            keepNext: true,
            widowControl: true,
          }),
        ],

        footers: {
          default: new Footer({
            children: [
              new Paragraph({
                border: {
                  top: {
                    color: 'auto',
                    space: 1,
                    style: BorderStyle.SINGLE,
                    size: 6,
                  },
                },
                alignment: AlignmentType.JUSTIFIED,
                children: [
                  new TextRun({text: `${footerArticle.bold1}`, bold: true}),
                  new TextRun({text: `${footerArticle.text1}`}),
                ],
              }),

              new Paragraph({
                border: {
                  top: {
                    color: 'auto',
                    space: 1,
                    style: BorderStyle.SINGLE,
                    size: 6,
                  },
                },
                alignment: AlignmentType.JUSTIFIED,
                children: [
                  new TextRun({text: `${footerArticle.bold2}`, bold: true}),
                  new TextRun({text: `${footerArticle.text2}`}),
                ],
              }),

              new Paragraph({
                alignment: AlignmentType.RIGHT,
                children: [
                  new TextRun({
                    children: ['str. ', PageNumber.CURRENT, ' od ', PageNumber.TOTAL_PAGES],
                  }),
                ],
              }),
            ],
          }),
        },
      },
    ],
  })

  Packer.toBlob(doc).then((blob) => {
    const fileName = `Izvod - JRR FBiH - ${FullName} - ${today}`
    saveAs(blob, `${fileName}.docx`)
  })
}
